export class DicomData {
    batchId: any;
    totalFileCount: number;
    dicomFolder: any;
    validDicom: any;
    invalidDicom:any;
    uploadDate: any;
}